/**
 * Utilitários Centrais de Formatação Móvel
 * ----------------------------------------
 * Centraliza moedas, datas e constantes de calendário
 * garantindo o princípio DRY (Don't Repeat Yourself).
 */

export const MONTHS_PT = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
];

export const MONTHS_SHORT_PT = [
    "Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
    "Jul", "Ago", "Set", "Out", "Nov", "Dez"
];

export const WEEK_DAYS_SHORT_PT = [
    "Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"
];

/**
 * Formata um valor numérico para Moeda Euro (€)
 * Exemplo: 1250.5 -> "1.250,50 €"
 */
export const formatCurrency = (value?: number | null): string => {
    return new Intl.NumberFormat("pt-PT", {
        style: "currency",
        currency: "EUR",
    }).format(value ?? 0);
};

/**
 * Formata uma data para o padrão PT (dd/mm/aaaa)
 * Exemplo: Date -> "24/09/2026"
 */
export const formatDatePT = (date?: Date | string | null): string => {
    if (!date) return "-";
    return new Date(date).toLocaleDateString("pt-PT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });
};

/**
 * Formata uma data com hora para o padrão PT
 * Exemplo: Date -> "24/09/2026 14:30"
 */
export const formatDateTimePT = (date?: Date | string | null): string => {
    if (!date) return "-";
    return new Date(date).toLocaleString("pt-PT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

export const formatDate = formatDatePT;